import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faPeopleCarry, faUserFriends, faHeadset } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet';
import { faLocationArrow, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import '../css/Career.css';

const CareerItem = ({ icon, title, description }) => {
    return (




        
        
        <div className="col-lg-6 mb-4">
            <div className="career-item p-4 shadow-sm rounded">
                <div className="career-icon mb-3 text-center">
                    <FontAwesomeIcon icon={icon} size="3x" className="text-primary" />
                </div>
                <h4 className="career-title text-center">
                    <a href="#" className="text-dark">{title}</a>
                </h4>
                <p>{description}</p>
            </div>
        </div>
    );
};

const CareersSection = () => {
    return (
        <div>
           

            <section id="about" className="jarallax text-light">
    <div className="center-y relative text-center">
        <div className="container">
            <div className="row">
                <div className="col-md-12 text-center">
                    <h1 className='text-white'>Career</h1>
                </div>
                <div className="clearfix"></div>
            </div>
        </div>
    </div>
</section>





          
<section aria-label="Careers" className="bg-light py-5">
    <div className="container px-0">
        <div className="row g-2 container">
            <div className="col-12 text-center mb-5">
                <h2 className="section-title">Join the AB Ghule Cabs Team</h2>
                <p className="section-subtitle">
                    Explore rewarding career opportunities with AB Ghule Cabs and become part of our growing family.
                </p>
            </div>
            <CareerItem 
                className=""
                icon={faCar}
                title="Cab Driver"
                description="As a cab driver with AB Ghule Cabs, you'll play a vital role in delivering top-notch transportation services. Your professionalism, commitment to safety, and customer-focused attitude will ensure every passenger enjoys a smooth and pleasant ride. Join our team and help us make travel easier and more enjoyable for everyone!"
            />
            <CareerItem
                icon={faPeopleCarry}
                title="Customer Support Executive"
                description="Our customer support team is the backbone of AB Ghule Cabs. As a support executive, you'll assist clients with booking inquiries, troubleshooting, and ensuring their satisfaction. Your efforts will help build lasting relationships with customers and keep our services running smoothly."
            />
            <CareerItem
                icon={faUserFriends}
                title="Travel Consultant"
                description="Become a travel consultant with AB Ghule Cabs and help our clients plan their trips with personalized travel solutions. Your expertise in understanding customer needs will ensure every journey is tailored to provide the best experience possible."
            />
            <CareerItem
                icon={faHeadset}
                title="Operations Coordinator"
                description="As an operations coordinator, you'll be responsible for managing the logistics of our fleet and ensuring operations. Your ability to coordinate drivers, monitor schedules, and solve problems on the go will ensure every ride is timely, safe, and efficient."
            />
        </div>
    </div>
</section>

<div className="twm-get-info-wrap ">
                  <ul className="row container">
                    {/* Phone */}
                    <li className="col-12 col-md-4">
                      <div className="twm-get-info">
                        <div className="twm-media">
                          <i className="feather feather-phone-call"></i>
                        </div>
                        <div className="twm-content">
                          <p>Phone</p>
                          <h3 className="twm-title">
                            <a href="tel:+918624029699">+91 8624029699</a> <br></br>
                          </h3>
                        </div>
                      </div>
                    </li>

                    {/* Email */}
                    <li className="col-12 col-md-4 ">
                      <div className="twm-get-info">
                        <div className="twm-media">
                          <i className="feather feather-mail"></i>
                        </div>
                        <div className="twm-content">
                          <p>Email</p>
                          <a href="mailto:booking@abghulecabs.com">
                            <h4>booking@abghulecabs.com</h4>
                            </a>

                        </div>
                      </div>
                    </li>

                    {/* Address */}
                    <li className="col-12 col-md-4">
                      <div className="twm-get-info">
                        <div className="twm-media">
                          <i className="feather feather-home"></i>
                        </div>
                        <div className="twm-content">
                          <p>Address</p>
                          <h3 className="twm-title">AB Ghule Cabs <br></br>
                          R -10 Office No -1606,<br/>
                          
                          Life Republic Mulshi,Marunji <br></br>
                         Pune,
                          Maharashtra - 411057.
                          </h3>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>


        </div>
    );
};

export default CareersSection;
